"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "8d85d074-5ef3-443b-a5fe-1cfc74be6a9d",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-hi"), /*#__PURE__*/React.createElement("g", {
    id: "81d28a6c-dd10-4de0-87bd-20960d0be7ff",
    "data-name": "document-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1faebdd3-c92f-4b49-be0b-8e11ec36ebd3",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a8346cdb-3823-4c98-b01d-c8386743af8e",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "150d4c11-71fe-42f4-90b4-0ad9c4a3a715",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02601a65-cc98-42c7-9a26-7290a0d74d6c",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "451ac7f8-0d2e-4056-b607-7fdb15cd6fb0",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f965ac3-a8fd-4e8d-b1df-544e9299490e",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3a139e8a-b704-4f78-9e6a-5ecec5c6a1f0",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9027abba-0458-447c-b45f-00f5b019d293",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "985797e4-eea7-4a92-8cfd-c24fb53a3ce7",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "62dd35b0-31c9-40f3-b581-b0a0f421a22d",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1e9e507e-1cfa-41c0-aac1-2ee02e732ef9",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#8d85d074-5ef3-443b-a5fe-1cfc74be6a9d)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 113,
    width: 64,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 129,
    width: 64,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 97,
    width: 64,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }))))))))))))));
}

var _default = ic_document;
exports.default = _default;